const userSelector = state => state.user;
const dashboardSelector = state => state.dashboard;

export { userSelector, dashboardSelector };
